import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pj6de6xdyos2">
        <h2 className="text-center font-display text-[1.6rem] font-bold uppercase leading-none text-white sm:text-[2.2rem]" data-id="element-20" data-mp="avcw8hsnje7d">
          5 PREMIUM <span className="text-volt" data-id="element-21" data-mp="fsv9ulhm6hlp">BONUSES INCLUDED</span>
        </h2>
        <div className="mt-2 space-y-2" data-id="element-22" data-mp="1tvjn9egdunf">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border border-steel/20 border-l-4 border-l-volt bg-carbon px-2.5 py-2" data-id="element-23" data-mp="5w0cw70zop9j">
              <h3 className="text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-volt sm:text-[0.88rem]" data-id="element-24" data-mp="3o2n2xvnk40i2">
                🎁 BONUS {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.92rem]" data-id="element-25" data-mp="1mba0dd92a4p6">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}